import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { loginRequest } from "../../redux/auth/jobseeker_login/actions";
import { Col, Container, Row } from "reactstrap";
import { showToast } from "../../Components/Common/Toast";
import { getTotalPointsRequest } from "../../redux/get_total_points/actions";
import { reset } from "../../redux/auth/jobseeker_login/actions";
import Spinner from "../../Components/Common/Spinner";
import { getSafePostLoginRedirect } from "../../utils/postLoginRedirect";

const CentralCallback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const loginReducerData = useSelector((state) => state.jobseekerLoginReducer);
  const loginData = loginReducerData.data;
  console.log("loginData", loginData);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    console.log("token22", token);

    if (token) {
      const formattedData = {
        token: token,
      };
      dispatch(loginRequest(formattedData));
    }
  }, [dispatch, location]);

  useEffect(() => {
    if (loginReducerData.status && loginReducerData.message) {
      showToast("success", loginReducerData.message);
      dispatch(reset());

      const user_data = {
        name: loginData.name,
        email: loginData.email,
        type: loginData.type,
        phone: loginData.phone ?? "",
      };
      localStorage.setItem("_token", loginData.token);
      localStorage.setItem("user_data", JSON.stringify(user_data));

      const qp = new URLSearchParams(location.search);
      let red = qp.get("redirect");
      if (!red) {
        try {
          red = sessionStorage.getItem("naukrify_post_login_redirect");
        } catch (e) {
          red = null;
        }
      }
      try {
        sessionStorage.removeItem("naukrify_post_login_redirect");
      } catch (e) {}
      const safe = getSafePostLoginRedirect(red, "JOBSEEKER");
      navigate(safe || `${process.env.PUBLIC_URL}/jobseeker/dashboard`);

      dispatch(getTotalPointsRequest());
    } else if (!loginReducerData.status && loginReducerData.message) {
      showToast("error", loginReducerData.message);
      dispatch(reset());
      navigate(`${process.env.PUBLIC_URL}/jobseeker/auth/login`);

    }
  }, [loginReducerData, dispatch, navigate, loginData, location.search]);

  return (
    <Container className="h-100">
      <Row className="h-100">
        <Col className="d-flex justify-content-center align-items-center">
          {loginReducerData.isLoading ? (
            <>
              <Spinner color="primary" />

            </>
          ) : (
            <p>Please wait...</p>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default CentralCallback;
